export default __webpack_public_path__ + "static/media/feather_home.b0b9e283.svg";